import React, {useEffect} from 'react'
const Notfound = () => {
    useEffect(() => {
        document.title = '404 NOT FOUND'; // Change the title as desired
        // Make sure to replace 'Your Website Name' with your actual website name
      }, []);
  return (
   <>
<div className="min-h-screen flex flex-col items-center justify-center bg-gray-900">
  <div className="w-72 bg-gray-800 rounded-lg shadow-lg p-16 mx-4 md:mx-auto md:w-1/2 lg:w-1/3 xl:w-1/4">
    <h1 className="text-7xl font-semibold text-red-400 mb-8">404</h1>
    <p className="text-gray-300 text-2xl mb-8">Oops! The page you're looking for does not exist.</p> 
    <p className="text-gray-300 text-2xl mb-8">Please check the URL and enter the correct URL.</p> 
    <a href="/" className="text-blue-400 hover:underline text-2xl">Go back to the home page</a>
  </div>
</div>

   </>
  )
}

export default Notfound